import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	betweenWidths,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	minWidth,
} from '@calm-web/design-system';

import CircleCheck from 'icons/circle-check.svg';

export const Wrapper = styled.div`
	color: ${palette('white')};
	display: flex;
	justify-content: center;
	padding: 1.5rem 2rem;
	position: relative;
	text-align: left;
	z-index: 0;

	${minWidth('desktop')} {
		padding: 6.66rem 1.11rem 1.11rem 4.5rem;
		min-height: 100vh;
	}

	&:after {
		background: rgba(0, 0, 0, 0.5);
		bottom: 0;
		content: '';
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
		z-index: -1;
	}
`;

export const Container = styled.div`
	width: 100%;

	${minWidth('desktop')} {
		width: auto;
	}
`;

export const Icon = styled.img`
	display: block;
	height: 4.44rem;
	margin: 0 auto 0.66rem;
	width: 4.44rem;

	${minWidth('desktop')} {
		height: 7.11rem;
		margin: 0 0 1.77rem;
		width: 7.11rem;
	}
`;

export const Heading = styled.h1`
	color: ${palette('white')};
	font-size: 2.44rem;
	font-weight: 900;
	margin-bottom: 0.66rem;
	line-height: 1.25;
	text-align: center;
	${minWidth('mobileLarge')} {
		font-size: 2.75rem;
	}
	${minWidth('desktop')} {
		font-size: 3rem;
		margin-bottom: 1.55rem;
		text-align: left;
	}
`;

export const Subheading = styled.h2`
	color: ${palette('white')};
	${fontSize(FontSizes.lg)};
	${fontWeight(FontWeights.Medium)};
	line-height: 0.97;
	margin-bottom: 1rem;
	text-align: center;
	${minWidth('desktop')} {
		text-align: left;
	}
`;

export const CountdownContainer = styled.div`
	display: flex;
	flex-direction: column;

	${betweenWidths('mobileLarge', 'desktop')} {
		align-items: center;
		flex-direction: row-reverse;
		justify-content: center;
	}
`;

export const BulletPoints = styled.ul`
	list-style: none;
	margin: 0 0 1.88rem;
	padding: 0;

	${betweenWidths('mobileLarge', 'desktop')} {
		margin: 0;
		width: 48%;
	}

	${minWidth('desktop')} {
		margin: 0 0 1.88rem;
	}
`;

export const BulletPoint = styled.li`
	align-items: flex-start;
	color: ${palette('white')};
	display: flex;
	${fontWeight(FontWeights.Medium)};
	${fontSize(FontSizes.base)};
	line-height: 1.5;
	margin: 0 0 0.5rem;
	padding-left: 0;
`;

export const CheckIcon = styled(CircleCheck)`
	flex: 0 0 1.27rem;
	height: 1.27rem;
	margin-right: 0.55rem;
	position: relative;
	top: 1px;
	width: 1.27rem;

	& path {
		fill: ${palette('white')};
	}
`;
